import React from "react";
import { useNavigate } from "react-router-dom";
import DashboardCard from "../../components/DashboardCard";
import { FaChartBar } from "react-icons/fa";

const ALevelMenu = ({ data }) => {
  const navigate = useNavigate();

  return (
    <DashboardCard
      icon={<FaChartBar />}
      title="O-Level"
      subtitle="Secondary Results"
      onClick={() => navigate("/app/olevel")}
      variant={data?.olevel >= 1 ? (data.result >= 6 ? "success" : "info") : "danger"}
      completed={data?.olevel >= 1 && data.result >= 6}
      index={2}
    />
  );
};

export default ALevelMenu;
